import React from 'react';
import { Colors } from '../../../themes/colors';
import { InfoIcon } from '../../../images/icons/InfoIcon';

/**
 * Light-blue informational callout (blue border, very light blue background, info icon).
 * Use for in-context hints next to a form field. Pass `style` to control width/spacing
 * so it can match the width of the field it annotates.
 */
export const InfoBox = ({ children, style = {}, showIcon = true }) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      padding: '8px 12px',
      backgroundColor: Colors.primary_50,
      border: `1px solid ${Colors.primary_300}`,
      borderRadius: 8,
      color: Colors.neutral_600,
      fontSize: 13,
      lineHeight: 1.35,
      ...style,
    }}
  >
    {showIcon && (
      <span style={{ flexShrink: 0, display: 'flex', alignSelf: 'flex-start' }}>
        <InfoIcon color={Colors.primary_500} />
      </span>
    )}
    <span>{children}</span>
  </div>
);
